// extracted by mini-css-extract-plugin
module.exports = {"grid":"_2K1-BJ"};